import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { driver } from "driver.js";
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import * as moment from 'moment';

@Component({
  selector: 'vex-live-streaming',
  templateUrl: './live-streaming.component.html',
  styleUrls: ['./live-streaming.component.scss']
})
export class LiveStreamingComponent implements OnInit {
  events;
  bookingSpinner: any = {
    spinner: false,
    eventId: ''
  };

  constructor(public guiService: GuiService, private restService: RestService, public translate: TranslateService) { }

  ngOnInit(){
    this.guiService.showSpinner = false;
    if (this.guiService.userLogged){
      this.getEvents();
    }else{
      this.guiService.goTo('main/home');
    }
  }

  getEvents(){
    this.restService.postService('node', '/list-stream-event',{userId: this.guiService.userLogged.user.id}).subscribe((ris)=>{
      this.events = ris;
      this.events.forEach(element => {
        element.dateFormatted = this.formatDateCustom(element.date);
      });
      this.bookingSpinner = {
        spinner: false,
        eventId: ''
      };
      setTimeout(() => {
        localStorage.getItem('tourStreamingShowed') ? null : this.startTour();
      }, 800);
    })
  }

  reservateEvent(eventId){
    const param = {
      userId: this.guiService.userLogged.user.id,
      eventId: eventId,
      acceptation: {
        userId: this.guiService.userLogged.user.id,
        name: this.guiService.userLogged.masterData.name,
        lastName: this.guiService.userLogged.masterData.lastName,
        email: this.guiService.userLogged.user.email
      }
    };

    this.bookingSpinner = {
      spinner: true,
      eventId: eventId
    };

    this.restService.postService('node', '/accept-stream-event',param).subscribe((ris)=>{
     this.getEvents()
     this.guiService.openSnackBar(this.translate.instant("STREAMING.BOOKED"),'ok');
    })
  }

  startTour(): void {
    localStorage.setItem('tourStreamingShowed', 'true');

    const driverObj = driver({
      showProgress: true,
      allowClose: true,
      steps: [
        { element: '.top-infos-streaming', popover: { title: this.translate.instant('TUTORIALS.live-streaming.discoverDetailsTitle'), description: this.translate.instant('TUTORIALS.live-streaming.discoverDetailsDescription') } },
        { element: '.time-event-tutorial', popover: { title: this.translate.instant('TUTORIALS.live-streaming.checkDateTimeTitle'), description: this.translate.instant('TUTORIALS.live-streaming.checkDateTimeDescription'), side: 'bottom' } },
        { element: '.book-streaming', popover: { title: this.translate.instant('TUTORIALS.live-streaming.clickRegisterTitle'), description: this.translate.instant('TUTORIALS.live-streaming.clickRegisterDescription') } }]
    });

    driverObj.drive();
  }

  formatDateCustom(date: string): string {
    const datePart = date.split('T')[0];
    const [year, month, day] = datePart.split('-');
    return day+'/'+month+'/'+year;
  }

}

